import { render, staticRenderFns } from "./AmErrorDisplay.vue?vue&type=template&id=c04a5628&scoped=true&"
import script from "./AmErrorDisplay.vue?vue&type=script&lang=js&"
export * from "./AmErrorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04a5628",
  null
  
)

export default component.exports